import { bind } from 'decko'
import { LiveNodeList } from 'live-node-list'

export default class SlideInAutoscroll {
  sections = new LiveNodeList('.slide-in-autoscroll')

  constructor() {
    if (!this.sections) {
      return
    }
    this.registerListeners()
  }

  /**
   *
   */
  @bind
  registerListeners() {
    this.sections.forEach(element => {
      this.initAnimation(element)
    })
  }

  @bind
  initAnimation(element) {
    const list = element.querySelector('.slide-in-autoscroll__list')
    element.addEventListener("animationstart", (event) => {
      list.classList.remove('autoscroll-running')
    })
    element.addEventListener("animationend", (event) => {
      list.classList.add('autoscroll-running')
      if (!list.classList.contains('show-duplicates')) {
        list.classList.add('show-duplicates')
      }
    })
  }


}
